'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var lc_menu = [{
  name: "MISSION",
  link: "https://www.lanl.gov/mission/index.php",
  lc_page_groups: []
}, {
  name: "SCIENCE & INNOVATION",
  link: "https://www.lanl.gov/science-innovation/index.php",
  lc_page_groups: [{
    name: "Science & Innovation",
    link: "https://www.lanl.gov/science-innovation/index.php",
    lc_pages: [{
      name: "Science Highlights",
      link: "https://www.lanl.gov/science-innovation/index.php"
    }, {
      name: "Science Briefs",
      link: "https://www.lanl.gov/discover/science-briefs/index.php"
    }, {
      name: "Science Facilities",
      link: "https://www.lanl.gov/science-innovation/science-facilities/index.php"
    }, {
      name: "Capability Pillars",
      link: "https://www.lanl.gov/science-innovation/pillars/index.php"
    }, {
      name: "Science Videos",
      link: "https://www.lanl.gov/science-innovation/science-videos1.php"
    }, {
      name: "Lab Organizations",
      link: "https://www.lanl.gov/org/index.php"
    }, {
      name: "Research Library",
      link: "http://www.lanl.gov/library/index.php"
    }]
  }, {
    name: "Science Programs",
    link: "https://www.lanl.gov/science-innovation/science-programs/index.php",
    lc_pages: [{
      name: "Applied Energy Programs",
      link: "https://www.lanl.gov/science-innovation/science-programs/applied-energy-programs/index.php"
    }, {
      name: "Civilian Nuclear Energy Programs",
      link: "https://www.lanl.gov/science-innovation/science-programs/civilian-nuclear-programs/index.php"
    }, {
      name: "Laboratory Directed Research & Development (LDRD)",
      link: "https://www.lanl.gov/science-innovation/science-programs/ldrd/index.php"
    }, {
      name: "National Security Education Center (NSEC)",
      link: "https://www.lanl.gov/projects//national-security-education-center/index.php"
    }, {
      name: "Office of Science Programs",
      link: "https://www.lanl.gov/science-innovation/science-programs/office-of-science-programs/index.php"
    }]
  }]
}, {
  name: "COLLABORATION",
  link: "https://www.lanl.gov/collaboration/index.php",
  lc_page_groups: [{
    name: "User Facilities",
    link: "https://www.lanl.gov/collaboration/user-facilities/index.php",
    lc_pages: [{
      name: "CINT",
      link: "http://cint.lanl.gov/index.php"
    }, {
      name: "LANSCE",
      link: "http://lansce.lanl.gov/"
    }, {
      name: "NHMFL",
      link: "https://nationalmaglab.org/user-facilities/pulsed-field-facility"
    }, {
      name: "Biosurveillance Gateway",
      link: "https://www.lanl.gov/projects//biosurveillance-gateway/index.php"
    }, {
      name: "Pathogen Databases",
      link: "https://www.lanl.gov/collaboration/pathogen-database/index.php"
    }]
  }, {
    name: "Feynman Center For Innovation",
    link: "https://www.lanl.gov/projects//feynman-center/index.shtml",
    lc_pages: [{
      name: "LACED",
      link: "https://www.lanl.gov/projects//explosives-detection/index.php"
    }, {
      name: "Exascale Computing Project",
      link: "https://www.lanl.gov/projects//exascale-computing-project/index.php"
    }, {
      name: "FUTURE",
      link: "https://www.lanl.gov/projects//future/index.php"
    }]
  }, {
    name: "National Security Education Center (NSEC)",
    link: "https://www.lanl.gov/projects//national-security-education-center/index.php",
    lc_pages: [{
      name: "Center for Nonlinear Studies",
      link: "https://www.lanl.gov/projects//national-security-education-center/center-nonlinear-studies/index.php"
    }, {
      name: "Engineering Institute",
      link: "https://www.lanl.gov/projects//national-security-education-center/engineering/index.php"
    }, {
      name: "Information Science & Technology Institute",
      link: "https://www.lanl.gov/projects//national-security-education-center/information-science-technology/index.php"
    }, {
      name: "Center for Space and Earth Science",
      link: "https://www.lanl.gov/projects//national-security-education-center/space-earth-center/index.php"
    }, {
      name: "Institute for Materials Science",
      link: "https://www.lanl.gov/projects//national-security-education-center/institute-for-materials-science/index.php"
    }, {
      name: "Seaborg Institute",
      link: "https://www.lanl.gov/projects//national-security-education-center/seaborg/index.php"
    }, {
      name: "Fellows",
      link: "https://www.lanl.gov/collaboration/fellows/index.php"
    }]
  }, {
    name: "Research Opportunities",
    link: "https://www.lanl.gov/collaboration/research-opportunities/index.php",
    lc_pages: [{
      name: "Service Academies and ROTC Research Associates",
      link: "https://www.lanl.gov/collaboration/internships/service-academy-research-associates/index.php"
    }, {
      name: "Strategic Analyses and Assessments Office",
      link: "https://www.lanl.gov/projects/strategic-analyses-and-assessments/index.php"
    }]
  }]
}, {
  name: "COMMUNITY",
  link: "https://www.lanl.gov/community/index.php",
  lc_page_groups: [{
    name: "Community Commitment",
    link: "https://www.lanl.gov/community/index.php",
    lc_pages: [{
      name: "Giving campaigns, drives",
      link: "https://www.lanl.gov/community/giving/index.php"
    }, {
      name: "Economic development",
      link: "https://www.lanl.gov/community/economic-development.php"
    }, {
      name: "Grants and Sponsorships",
      link: "https://www.lanl.gov/community/grantapplication.php"
    }]
  }, {
    name: "Stem Education",
    link: "https://www.lanl.gov/community/education/index.php",
    lc_pages: [{
      name: "Teachers (K-12)",
      link: "https://www.lanl.gov/community/education/stem-education-programs.php"
    }, {
      name: "Students (K-12)",
      link: "https://www.lanl.gov/community/education/teacher-resources/index.php"
    }, {
      name: "Higher education",
      link: "https://www.lanl.gov/community/education/higher-education-resources/index.php"
    }, {
      name: "Regional education partners",
      link: "https://www.lanl.gov/community/education/regional-partners/index.php"
    }, {
      name: "NM Governor's STEM Challenge",
      link: "https://www.lanl.gov/community/education/stem-challenge/index.php"
    }]
  }, {
    name: "Internal",
    link: "https://www.lanl.gov/community/visitors/index.php",
    lc_pages: [{
      name: "Badging, Badge Office",
      link: "https://www.lanl.gov/community/visitors/badging/index.php"
    }, {
      name: "Bradbury Science Museum",
      link: "https://www.lanl.gov/community/visitors/bradbury-science-museum.php"
    }, {
      name: "Housing",
      link: "https://www.lanl.gov/community/visitors/housing.php"
    }, {
      name: "Maps",
      link: "https://www.lanl.gov/resources/maps.php"
    }]
  }, {
    name: "Related Resources",
    link: null,
    lc_pages: [{
      name: "Calendar",
      link: "http://www.lanl.gov/calendar/"
    }, {
      name: "Community Connections",
      link: "https://discover.lanl.gov/publications/connections"
    }, {
      name: "Community feature stories",
      link: "https://www.lanl.gov/community/stories/index.php"
    }]
  }]
}, {
  name: "ENVIRONMENT",
  link: "https://www.lanl.gov/environment/index.php",
  lc_page_groups: [{
    name: "Environmental Protection",
    link: "https://www.lanl.gov/environment/protection/index.php",
    lc_pages: [{
      name: "What we monitor and why",
      link: "https://www.lanl.gov/environment/protection/monitoring/index.php"
    }, {
      name: "Cultural preservation",
      link: "https://www.lanl.gov/environment/protection/cultural-preservation/index.php"
    }, {
      name: "Taking care of our trails",
      link: "https://www.lanl.gov/environment/protection/trails/index.php"
    }, {
      name: "Obeying environmental laws",
      link: "https://www.lanl.gov/environment/protection/compliance/index.php"
    }, {
      name: "Protecting Wildlife",
      link: "https://www.lanl.gov/environment/protection/wildlife-protection/index.php"
    }]
  }, {
    name: "Environmental Sustainability",
    link: "https://sustainability.lanl.gov/",
    lc_pages: [{
      name: "Sustainability goals",
      link: "https://sustainability.lanl.gov/goals-and-progress"
    }, {
      name: "Recycling",
      link: "https://www.lanl.gov/environment/sustainability/recycling.php"
    }, {
      name: "Green purchasing",
      link: "https://www.lanl.gov/environment/sustainability/green-purchasing.php"
    }, {
      name: "Pollution prevention",
      link: "https://www.lanl.gov/environment/sustainability/pollution-prevention.php"
    }, {
      name: "Reusing water",
      link: "https://www.lanl.gov/environment/sustainability/water-reuse.php"
    }]
  }, {
    name: "Resources",
    link: null,
    lc_pages: [{
      name: "Environmental Management System",
      link: "https://www.lanl.gov/environment/protection/environmental-management-system.php"
    }, {
      name: "Feature stories",
      link: "https://www.lanl.gov/environment/stories/index.php"
    }, {
      name: "Public Reading Room",
      link: "https://www.lanl.gov/environment/public-reading-room.php"
    }]
  }, {
    name: "Environment Home",
    link: "https://www.lanl.gov/environment/index.php",
    lc_pages: []
  }]
}];
var lc_utility_menu = [{
  name: "Quick Links",
  lc_utility_item: [{
    name: "About",
    link: "https://www.lanl.gov/about/index.php"
  }, {
    name: "Badging",
    link: "https://www.lanl.gov/community/visitors/badging/index.php"
  }, {
    name: "Business",
    link: "https://www.lanl.gov/business/procurement-opportunities.php"
  }, {
    name: "Contacts",
    link: "https://www.lanl.gov/resources/contacts.php"
  }, {
    name: "Maps",
    link: "https://www.lanl.gov/resources/maps.php"
  }, {
    name: "Mission",
    link: "https://www.lanl.gov/mission/index.php"
  }, {
    name: "Museum",
    link: "https://www.lanl.gov/museum//index.php"
  }, {
    name: "Organizations",
    link: "https://www.lanl.gov/org/index.php"
  }, {
    name: "New Hires",
    link: "https://www.lanl.gov/careers/employees-retirees/new-hires/index.php"
  }, {
    name: "Publications",
    link: "https://www.lanl.gov/discover/publications/index.php"
  }, {
    name: "Research Library",
    link: "http://www.lanl.gov/library//index.php"
  }]
}];
var menu_articles_environment = [];
var menu_articles_community = [{
  card_image: {
    id: "b0ed94c0-27a6-4bd3-92da-e439fe6acfdd",
    filename_disk: "b0ed94c0-27a6-4bd3-92da-e439fe6acfdd.jpg",
    title: "2022-03-09 card",
    width: 1400,
    height: 1120
  },
  feature_image: null,
  news_type: {
    slug: "stories"
  },
  slug: "0309-senate-recognizes-researchers",
  title: "New Mexico Senate recognizes more than 100 Laboratory COVID-19 researchers for contributions to the state and nation",
  status: "published"
}, {
  card_image: {
    id: "2868a7c9-ac4c-4ad6-a578-b13d0980855f",
    filename_disk: "2868a7c9-ac4c-4ad6-a578-b13d0980855f.jpg",
    title: "2022-03-07",
    width: 1400,
    height: 1120
  },
  feature_image: null,
  news_type: {
    slug: "stories"
  },
  slug: "0307-summer-physics-camp",
  title: "Attention all New Mexico girls: Apply for a free summer physics camp!",
  status: "published"
}, {
  card_image: {
    id: "ef296c9c-f3e4-4f5e-ba71-b7d6bac5981d",
    filename_disk: "ef296c9c-f3e4-4f5e-ba71-b7d6bac5981d.jpg",
    title: "2022-03-04 News Card@2x",
    width: 1400,
    height: 1120
  },
  feature_image: {
    id: "30876ee7-fa9b-42d8-93fe-72bfb93e064f",
    filename_disk: "30876ee7-fa9b-42d8-93fe-72bfb93e064f.jpg",
    title: "2022-03-04",
    width: 1200,
    height: 795
  },
  news_type: {
    slug: "stories"
  },
  slug: "0304-mukundan-smithsonian-exhibit",
  title: "Smithsonian exhibit features STEM ambassadors with statues, exhibit",
  status: "published"
}];
var menu_articles_science = [{
  card_image: {
    id: "68cc29e9-478f-487e-87d5-d555e5c29046",
    filename_disk: "68cc29e9-478f-487e-87d5-d555e5c29046.jpg",
    title: "2022-03-09 Card@2x",
    width: 1400,
    height: 1120
  },
  feature_image: {
    id: "f213b1fe-00d9-4aaa-949e-7af26325734f",
    filename_disk: "f213b1fe-00d9-4aaa-949e-7af26325734f.jpg",
    title: "2022-03-09 story",
    width: 700,
    height: 470
  },
  news_type: {
    slug: "stories"
  },
  slug: "0309-superconductivity",
  title: "Clues about unconventional superconductivity may unlock new applications",
  status: "published"
}, {
  card_image: {
    id: "3e848c7e-9674-458f-95a4-1e25a2331cc6",
    filename_disk: "3e848c7e-9674-458f-95a4-1e25a2331cc6.jpg",
    title: "2022-02-14 card",
    width: 1400,
    height: 1120
  },
  feature_image: {
    id: "264ee46b-aadd-41b4-a2eb-dfc27bebe679",
    filename_disk: "264ee46b-aadd-41b4-a2eb-dfc27bebe679.jpg",
    title: "2022-02-14",
    width: 2000,
    height: 1200
  },
  news_type: {
    slug: "stories"
  },
  slug: "0214-sf-new-mexican-bark-beetles",
  title: "Tiny beetle hits forests hard in warm droughts",
  status: "published"
}, {
  card_image: {
    id: "73b91fde-c119-431c-9eaa-8fb8c3576517",
    filename_disk: "73b91fde-c119-431c-9eaa-8fb8c3576517.jpg",
    title: "2022-02-03",
    width: 1400,
    height: 1120
  },
  feature_image: {
    id: "65f7b959-911d-44a5-99b1-53827c570da5",
    filename_disk: "65f7b959-911d-44a5-99b1-53827c570da5.jpg",
    title: "2022-02-30",
    width: 1800,
    height: 1200
  },
  news_type: {
    slug: "stories"
  },
  slug: "0203-polymer-fuel-cells",
  title: "New polymer fuel cells can operate at higher temperatures",
  status: "published"
}, {
  card_image: null,
  feature_image: {
    id: "548e81a8-9ce2-4e1f-a5a1-4c9e2be29a8b",
    filename_disk: "548e81a8-9ce2-4e1f-a5a1-4c9e2be29a8b.jpg",
    title: "2022-01-26",
    width: 1210,
    height: 908
  },
  news_type: {
    slug: "stories"
  },
  slug: "0126-burning-plasma",
  title: "New experiment results bolster potential for self-sustaining fusion",
  status: "published"
}, {
  card_image: null,
  feature_image: {
    id: "e000853f-816b-434d-b894-d347866ef776",
    filename_disk: "e000853f-816b-434d-b894-d347866ef776.jpg",
    title: "2021-12-22",
    width: 1225,
    height: 720
  },
  news_type: {
    slug: "stories"
  },
  slug: "1222-top-science-stories",
  title: "From battling COVID-19 and cancer to searching for signs of ancient life on Mars, see Los Alamos’ top stories from 2021",
  status: "published"
}, {
  card_image: null,
  feature_image: {
    id: "7ef5f628-336b-4660-b741-24987a42bcd9",
    filename_disk: "7ef5f628-336b-4660-b741-24987a42bcd9.jpg",
    title: "F 35 B61 12",
    width: 2200,
    height: 1080
  },
  news_type: {
    slug: "releases"
  },
  slug: "1220-b61-12-reaches-milestone",
  title: "B61-12 bomb reaches major milestone",
  status: "published"
}];
var navData = {
  lc_menu: lc_menu,
  lc_utility_menu: lc_utility_menu,
  menu_articles_environment: menu_articles_environment,
  menu_articles_community: menu_articles_community,
  menu_articles_science: menu_articles_science
};
exports['default'] = navData;
exports.lc_menu = lc_menu;
exports.lc_utility_menu = lc_utility_menu;
exports.menu_articles_community = menu_articles_community;
exports.menu_articles_environment = menu_articles_environment;
exports.menu_articles_science = menu_articles_science;